export enum AbuseReportReason {
  SPAM = "SPAM",
  OFFENSIVE = "OFFENSIVE",
  IP = "IP",
  OTHER = "OTHER"
}

export interface AbuseReportRequestInterface {
  content_type_str: string;
  object_id: string;
  reason: AbuseReportReason;
  additional_information?: string;
}

export interface AbuseReportCheckResponseInterface {
  has_abuse_report: boolean;
}

export interface AbuseReportContentTypeMap {
  post: "pybb.post";
  topic: "pybb.topic";
  message: "threaded_messages.message";
  comment: "nested_comments.nestedcomment";
}

export const ABUSE_REPORT_CONTENT_TYPES: AbuseReportContentTypeMap = {
  post: "pybb.post",
  topic: "pybb.topic",
  message: "threaded_messages.message",
  comment: "nested_comments.nestedcomment"
};

export const ABUSE_REPORT_REASON_LABELS = {
  [AbuseReportReason.SPAM]: "Spam/Fraudulent",
  [AbuseReportReason.OFFENSIVE]: "Offensive Content",
  [AbuseReportReason.IP]: "Intellectual Property Violation",
  [AbuseReportReason.OTHER]: "Other"
};
